
    import Ember from 'ember';
    import "coffeescripts/ember/shared/helpers/common";
import "i18n!screenreader_gradebook.student_information.assignment_subtotals";

    Ember.TEMPLATES['student_information/assignment_subtotals'] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n        <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "grading_period_8b0a4a10", "Grading Period", options) : helperMissing.call(depth0, "t", "grading_period_8b0a4a10", "Grading Period", options))));
  data.buffer.push("</th>\n      ");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n        <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "assignment_group_1a781505", "Assignment Group", options) : helperMissing.call(depth0, "t", "assignment_group_1a781505", "Assignment Group", options))));
  data.buffer.push("</th>\n      ");
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n        ");
  data.buffer.push(escapeExpression((helper = helpers['assignment-subtotal-grades'] || (depth0 && depth0['assignment-subtotal-grades']),options={hash:{
    'subtotal': ("assignment_subtotal"),
    'student': ("selectedStudent"),
    'weightingScheme': ("weightingScheme"),
    'gradingStandard': ("ENV.GRADEBOOK_OPTIONS.grading_standard")
  },hashTypes:{'subtotal': "ID",'student': "ID",'weightingScheme': "ID",'gradingStandard': "ID"},hashContexts:{'subtotal': depth0,'student': depth0,'weightingScheme': depth0,'gradingStandard': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "assignment-subtotal-grades", options))));
  data.buffer.push("\n      ");
  return buffer;
  }

  data.buffer.push("<div class=\"ic-Table-responsive-x-scroll\">\n  <table class=\"ic-Table\">\n    <thead>\n      <tr>\n      ");
  stack1 = helpers['if'].call(depth0, "subtotal_by_period", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n        <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.student_information.assignment_subtotals")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "ag_group_grade", "Grade", options) : helperMissing.call(depth0, "t", "ag_group_grade", "Grade", options))));
  data.buffer.push("</th>\n        <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.student_information.assignment_subtotals")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "ag_letter_grade", "Letter Grade", options) : helperMissing.call(depth0, "t", "ag_letter_grade", "Letter Grade", options))));
  data.buffer.push("</th>\n        <th scope=\"col\">");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("screenreader_gradebook.student_information.assignment_subtotals")
  },hashTypes:{'scope': "STRING"},hashContexts:{'scope': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "ag_group_percent_grade", "% of Grade", options) : helperMissing.call(depth0, "t", "ag_group_percent_grade", "% of Grade", options))));
  data.buffer.push("</th>\n      </tr>\n    </thead>\n    <tbody>\n      ");
  stack1 = helpers.each.call(depth0, "assignment_subtotal", "in", "assignment_subtotals", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(5, program5, data),contexts:[depth0,depth0,depth0],types:["ID","ID","ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n    </tbody>\n  </table>\n</div>\n");
  return buffer;
  
});
  